// extracted by mini-css-extract-plugin
module.exports = {"button":"_mQ","primary":"_mR","disabled":"_mS"};